import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ResultpagesharedService } from '../../../../service/resultpageshared.service';
import {
  CustomerRatingsSummary,
  RatingBreakdown,
} from 'src/app/share/type/customer-ratings_type';
import { Ratings } from 'src/app/share/type/result_type';

@Component({
  selector: 'app-customer-ratings',
  templateUrl: './customer-ratings.component.html',
  styleUrls: ['./customer-ratings.component.scss'],
})
export class CustomerRatingsComponent implements OnInit, OnChanges {
  @Input() productId!: string;
  @Input() bankName!: string;

  // Component state
  public ratingsData: CustomerRatingsSummary | null = null;
  public isLoading: boolean = false;
  public hasError: boolean = false;

  // Component properties for display
  get averageRating(): number {
    return this.ratingsData?.averageRating || 0;
  }

  get totalReviews(): number {
    return this.ratingsData?.totalReviews || 0;
  }

  get ratingBreakdown(): RatingBreakdown[] {
    return this.ratingsData?.ratingBreakdown || [];
  }

  constructor(private resultpagesharedService: ResultpagesharedService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    // Handle both initial load and subsequent changes
    if (changes['productId'] && changes['productId'].currentValue) {
      this.loadCustomerRatings();
    }
  }

  private loadCustomerRatings(): void {
    if (!this.productId) {
      this.hasError = true;
      return;
    }

    this.isLoading = true;
    this.hasError = false;

    try {
      // Get rating from resultpageshared service using centralized method
      const matchingRating =
        this.resultpagesharedService.getCustomerRatingByProductId(
          this.productId
        );

      if (matchingRating) {
        this.ratingsData = this.transformRatingsData(matchingRating);
        this.hasError = false;
      } else {
        this.hasError = true;
      }

      this.isLoading = false;
    } catch (error) {
      console.error('Failed to load customer ratings:', error);
      this.hasError = true;
      this.isLoading = false;
    }
  }

  private transformRatingsData(rating: Ratings): CustomerRatingsSummary {
    const ratingBreakdown: RatingBreakdown[] = [
      { stars: 5, count: rating.rates['5'] || 0, label: '5 Sterne' },
      { stars: 4, count: rating.rates['4'] || 0, label: '4 Sterne' },
      { stars: 3, count: rating.rates['3'] || 0, label: '3 Sterne' },
      { stars: 2, count: rating.rates['2'] || 0, label: '2 Sterne' },
      { stars: 1, count: rating.rates['1'] || 0, label: '1 Stern' },
    ];

    return {
      bankName: this.bankName,
      averageRating: rating.averageRate || 0,
      maxStars: 5,
      totalReviews: rating.totalRaters || 0,
      ratingBreakdown,
    };
  }

  // Calculate percentage for rating bar
  getRatingPercentage(count: number): number {
    return (count / this.totalReviews) * 100;
  }

  trackByStars(index: number, rating: RatingBreakdown): number {
    return rating.stars ?? index;
  }
}
